import { MatIconModule } from '@angular/material/icon';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MaterialModule } from '@shared/modules/material.module';
import { PromocionesComponent } from '@p-p-portafolio/promociones/promociones-component/promociones.component';
import { GenericFormComponent } from '@shared/components/generic-form/generic-form.component';
import { FormContentComponent } from '@shared/components/generic-form/components/form-content/form-content.component';
import { GenericTableComponent } from '@shared/components/generic-table/generic-table.component';
import { ConfirmDeletionComponent } from '@shared/components/confirm-deletion/confirm-deletion.component';
import { TasasComponent } from '@p-p-portafolio/tasas/tasas.component';
import { TasasFormComponent } from '@p-p-portafolio/tasas/tasas-form/tasas-form.component';
import { TasasHistoricoComponent } from '@p-p-portafolio/tasas/tasas-historico/tasas-historico.component';
import { ConceptosComponent } from '@p-p-portafolio/conceptos/conceptos.component';
import { CapitalesComponent } from '@p-p-portafolio/promociones/capitales/capitales.component';
import { CapitalesFormComponent } from '@p-p-portafolio/promociones/capitales/capitales-form/capitales-form.component';
import { FormaPagoComponent } from '@p-p-portafolio/formaPago/formaPago.component';
import { PlazosComponent } from '@p-p-portafolio/promociones/plazos/plazos.component';
import { PlazosFormComponent } from '@p-p-portafolio/promociones/plazos/plazos-form/plazos-form.component';
import { CiclosFormComponent } from '@p-p-portafolio/promociones/ciclos/ciclos-form/ciclos-form.component';
import { CiclosComponent } from '@p-p-portafolio/promociones/ciclos/ciclos.component';
import { ParametriaRoutes } from './parametria-layout-routing.module';
import { RouterModule } from '@angular/router';
import { IndexFuncionesComponent } from '@p-p-portafolio/promociones/index-funciones/index-funciones.component';
import { TipoCarteraComponent } from '@p-p-portafolio/tipoCartera/tipoCartera.component';
import { MovimientoCajaComponent } from '@p-p-portafolio/movimientoCaja/movimientoCaja.component';
import { MovimientoCajaFormComponent } from '@p-p-portafolio/movimientoCaja/movimientoCaja-form/movimientoCaja-form.component';
import { ContabilidadPromocionComponent } from '@p-p-portafolio/promociones/contabilidad-promocion/contabilidad-promocion.component';
import { DefinicionesComponent } from '@p-p-portafolio/promociones/definiciones/definiciones.component';
import { EstatusLegalesComponent } from '@p-p-portafolio/promociones/estatus-legales/estatus-legales.component';
import { EstatusComponent } from '@p-p-portafolio/estatus/estatus.component';
import { EstatusFormComponent } from '@p-p-portafolio/estatus/estatus-form/estatus-form.component';
import { SubestatusComponent } from '@p-p-portafolio/subestatus/subestatus.component';
import { SubestatusFormComponent } from '@p-p-portafolio/subestatus/formaPago-form/subestatus-form.component';
import { PromocionesFormComponent } from '@p-p-portafolio/promociones/promociones-component/promociones-form/promociones-form.component';
import { DefinicionesFormComponent } from '@p-p-portafolio/promociones/definiciones/definiciones-form/definiciones-form.component';
import { EstatusLegalesFormComponent } from '@p-p-portafolio/promociones/estatus-legales/estatus-legales-form/estatus-legales-form.component';
import { RolComponent } from '@pages/rol/rol/rol.component';
import { RolFormComponent } from '@pages/rol/rol-form/rol-form.component';
import { RangosComponent } from '@pages/rangos/rangos.component';
import { SelectEmpresaComponent } from '@shared/components/select-empresa/select-empresa.component';
import { SelectMonedaComponent } from '@shared/components/select-moneda/select-moneda.component';
import { SelectTasaComponent } from '@shared/components/select-tasa/select-tasa.component';
import { SelectConceptoComponent } from '@shared/components/select-concepto/select-concepto.component';
import { DefAperturaComponent } from '@p-p-portafolio/promociones/definiciones/definiciones-form/def-apertura/def-apertura.component';
import { DefGastosComponent } from '@p-p-portafolio/promociones/definiciones/definiciones-form/def-gastos/def-gastos.component';
import { DefBonificacionComponent } from '@p-p-portafolio/promociones/definiciones/definiciones-form/def-bonificacion/def-bonificacion.component';
import { DefLiquidacionComponent } from '@p-p-portafolio/promociones/definiciones/definiciones-form/def-liquidacion/def-liquidacion.component';
import { DefCargosCierreComponent } from '@p-p-portafolio/promociones/definiciones/definiciones-form/def-cargos-cierre/def-cargos-cierre.component';
import { DefExtraordinariosComponent } from '@p-p-portafolio/promociones/definiciones/definiciones-form/def-extraordinarios/def-extraordinarios.component';
import { DefSubsidioComponent } from '@p-p-portafolio/promociones/definiciones/definiciones-form/def-subsidio/def-subsidio.component';
import { RangosFormComponent } from '@pages/rangos/rangos-form/rangos-form.component';
import { VariablesComponent } from '@pages/variables/variables.component';
import { VariablesFormComponent } from '@pages/variables/variables-form/variables-form.component';
import { PerfilComponent } from '@pages/perfil/perfil.component';
import { ContabilidadFormComponent } from '@p-p-portafolio/promociones/contabilidad-promocion/contabilidad-form/contabilidad-form.component';
import { PerfilFormComponent } from '@pages/perfil/perfil-form/perfil-form.component';
import { ModulesFormComponent } from '@pages/modules-permission/modules-permission/modules-form/modules-form.component';
import { ModulesPermissionComponent } from '@pages/modules-permission/modules-permission.component';
import { SimuladorComponent } from '@p-p-portafolio/promociones/simulador/simulador.component';
import { AuditarComponent } from '@pages/auditar/auditar.component';
import { ControlPermissionComponent } from '@pages/modules-permission/control-permission/control-permission.component';
import { ControlFormComponent } from '@pages/modules-permission/control-permission/control-form/control-form.component';
import { ControlFormPermissionComponent } from '@pages/modules-permission/form-permission/control-form-permission/control-form-permission.component';
import { FormPermissionComponent } from '@pages/modules-permission/form-permission/form-permission.component';
import { TiposCreditoComponent } from '@pages/tipos-credito/tipos-credito.component';
import { CopiarTiposCreditoDialogComponent } from '@pages/tipos-credito/copiar-tipos-credito-dialog/copiar-tipos-credito-dialog.component';
import { TiposCreditoFormComponent } from '@pages/tipos-credito/tipos-credito-form/tipos-credito-form.component';
import { DuplicarModeloComponent } from '@pages/perfil/copiar/duplicar-modelo/duplicar-modelo.component';
import { ProductosComponent } from '@pages/productos/productos.component';
import { ProductosFormComponent } from '@pages/productos/productos-form/productos-form.component';
import { AbcMotivosComponent } from '@p-parametria/mantenimiento/abc-motivos/abc-motivos.component';
import { AbcMotivoFormComponent } from '@p-parametria/mantenimiento/abc-motivos/abc-motivo-form/abc-motivo-form.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { NgxCaptchaModule } from 'ngx-captcha';
//import { NgxGraphModule } from '@swimlane/ngx-graph';// swimlane/ngx-graph';
import { AbcEmpresasComponent } from '@p-parametria/mantenimiento/abc-empresas/abc-empresas.component';
import { ParametrosVariablesComponent } from '@p-parametria/parametros/parametros-variables/parametros-variables.component';
import { ParametrosVariablesFormComponent } from '@p-parametria/parametros/parametros-variables/parametros-variables-form/parametros-variables-form.component';
import { PrimeNgModule } from '@shared/modules/primeng.module';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AbcEmpresasCuentasComponent } from '../../pages/parametria/mantenimiento/abc-empresas/components/abc-empresas-cuentas/abc-empresas-cuentas.component';
import { AbcEmpresasFormComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-form/abc-empresas-form.component';
import { AbcMonedasComponent } from '@p-parametria/mantenimiento/abc-monedas/abc-monedas.component';
import { AbcMonedasFormComponent } from '@p-parametria/mantenimiento/abc-monedas/abc-monedas-form/abc-monedas-form.component';
import { AbcEmpresasSucursalesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-sucursales/abc-empresas-sucursales.component';
import { AbcEmpresasSucursalesFormComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-sucursales/abc-empresas-sucursales-form/abc-empresas-sucursales-form.component';
import { AbcEmpresasPromocionesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-sucursales/abc-empresas-promociones/abc-empresas-promociones.component';
import { AbcEmpresasPromocionesFormComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-sucursales/abc-empresas-promociones/abc-empresas-promociones-form/abc-empresas-promociones-form.component';
import { AbcMonedasParidadesComponent } from '@p-parametria/mantenimiento/abc-monedas/abc-monedas-paridades/abc-monedas-paridades.component';
import { AbcArticulosComponent } from '@p-parametria/mantenimiento/abc-articulos/abc-articulos.component';
import { AbcArticuloFormComponent } from '@p-parametria/mantenimiento/abc-articulos/abc-articulo-form/abc-articulo-form.component';
import { AbcListaPersonasComponent } from '@p-parametria/parametros/abc-lista-personas/abc-lista-personas.component';
import { AbcListaPersonasDialogComponent } from '@p-parametria/parametros/abc-lista-personas/abc-lista-personas-dialog/abc-lista-personas-dialog.component';
import { DestinosComponent } from '@p-p-portafolio/destinos/destinos.component';
import { DestinoFormComponent } from '@p-p-portafolio/destinos/destino-form.component';
import { RutaCriticaComponent } from '@p-p-portafolio/rutaCritica/ruta-critica.component';
import { RutaCriticaFormComponent } from '@p-p-portafolio/rutaCritica/ruta-critica-form.component';
import { RutasDialogComponent } from '@p-p-portafolio/rutaCritica/rutas-dialog.component';
import { RutaFormDialogComponent } from '@p-p-portafolio/rutaCritica/ruta-form-dialog.component';
import { ActividadesDialogComponent } from '@p-p-portafolio/rutaCritica/actividades-dialog.component';
import { CopiarRutaDialogComponent } from '@p-p-portafolio/rutaCritica/copiar-ruta-dialog.component';
import { ActividadFormDialogComponent } from '@p-p-portafolio/rutaCritica/actividad-form-dialog.component';
import { CuestionariosComponent } from '@p-p-portafolio/cuestionarios/cuestionarios.component';
import { CuestionarioDialogComponent } from '@p-p-portafolio/cuestionarios/cuestionario-dialog.component';
import { TiposDialogComponent } from '@p-p-portafolio/cuestionarios/tipos-dialog/tipos-dialog.component';
import { NuevoTipoDialogComponent } from '@p-p-portafolio/cuestionarios/tipos-dialog/nuevo-tipo-dialog.component';
import { CopiarCuestionarioDialogComponent } from '@p-p-portafolio/cuestionarios/copiar-cuestionario-dialog/copiar-cuestionario-dialog.component';
import { DocumentosComponent } from '@p-p-portafolio/documentos/documentos.component';
import { GirosComponent } from '@p-p-portafolio/giros/giros.component';
import { TitulosComponent } from '@p-p-portafolio/titulos/titulos.component';
import { DocumentoFormComponent } from '@p-p-portafolio/documentos/documento-form.component';
import { GiroFormComponent } from '@p-p-portafolio/giros/giro-form.component';
import { TituloFormComponent } from '@p-p-portafolio/titulos/titulo-form.component';
import { PromocionesCopyComponent } from '@p-p-portafolio/promociones/promociones-component/promociones-copy/promociones-copy.component';
import { PaisesComponent } from '@p-parametria/portafolio/paises/paises.component';
import { PaisFormComponent } from '@p-parametria/portafolio/paises/pais-form.component';
import { ChecklistComponent } from '@p-parametria/portafolio/checklist/checklist.component';
import { ChecklistFormComponent } from '@p-parametria/portafolio/checklist/checklist-form.component';
import { PreguntasDialogComponent } from '@p-parametria/portafolio/cuestionarios/preguntas-dialog/preguntas-dialog.component';
import { NuevaPreguntaDialogComponent } from '@p-parametria/portafolio/cuestionarios/preguntas-dialog/nueva-pregunta-dialog.component';
import { ParidadesComponent } from '@p-parametria/portafolio/paridades/paridades.component';
import { ParidadFormComponent } from '@p-parametria/portafolio/paridades/paridad-form.component';
import { VariablesFinancierasComponent } from '@p-parametria/portafolio/variables-financieras/variables-financieras.component';
import { VariableFinancieraFormComponent } from '@p-parametria/portafolio/variables-financieras/variable-financiera-form.component';
import { ZonaCiudadesComponent } from '@p-parametria/portafolio/zona-ciudades/zona-ciudades.component';
import { ZonaCiudadFormComponent } from '@p-parametria/portafolio/zona-ciudades/zona-ciudad-form.component';
import { ZonaCiudadListComponent } from '@p-parametria/portafolio/zona-ciudades/zona-ciudad-list.component';
import { ZonaCiudadFormCiudadComponent } from '@p-p-portafolio/zona-ciudades/zona-ciudad-form-ciudad.component';
import { RenumerarPreguntaDialogComponent } from '@p-parametria/portafolio/cuestionarios/preguntas-dialog/renumerar-pregunta-dialog.component';
import { GuionesDialogComponent } from '@p-parametria/portafolio/cuestionarios/preguntas-dialog/guiones-dialog.component';
import { NuevoGuionDialogComponent } from '@p-parametria/portafolio/cuestionarios/preguntas-dialog/nuevo-guion-dialog.component';
import { NuevaOpcionDialogComponent } from '@p-parametria/portafolio/cuestionarios/preguntas-dialog/nueva-opcion-dialog.component';
import { OpcionesDialogComponent } from '@p-parametria/portafolio/cuestionarios/preguntas-dialog/opciones-dialog.component';
import { ScriptDialogComponent } from '@p-p-portafolio/cuestionarios/preguntas-dialog/script-dialog.component';
import { NuevoScriptDialogComponent } from '@p-p-portafolio/cuestionarios/preguntas-dialog/nuevo-script-dialog.component';
import { CapturistasComponent } from '@p-parametria/control-usuarios/capturistas/capturistas.component';
import { CapturistaFormComponent } from '@p-parametria/control-usuarios/capturistas/capturista-form.component';
import { AnalistasComponent } from '@p-parametria/control-usuarios/analistas/analistas.component';
import { AnalistaFormComponent } from '@p-parametria/control-usuarios/analistas/analista-form.component';
import { AppSharedModule } from '@shared/modules/AppSharedModule.module';
import { DefCargosPagosComponent } from '@p-p-portafolio/promociones/definiciones/definiciones-form/def-cargos-pagos/def-cargos-pagos.component';
import { DefInteresesComponent } from '@p-p-portafolio/promociones/definiciones/definiciones-form/def-intereses/def-intereses.component';
import { TelemarketingComponent } from '@p-parametria/control-usuarios/telemarketing/telemarketing.component';
import { TelemarketingFormComponent } from '@p-parametria/control-usuarios/telemarketing/telemarketing-form.component';
import { GestoresComponent } from '@p-parametria/control-usuarios/gestores/gestores.component';
import { GestoresFormComponent } from '@p-parametria/control-usuarios/gestores/gestores-form.component';
import { AgendaModalComponent } from '@p-parametria/control-usuarios/gestores/agenda-modal/agenda-modal.component';
import { VendedoresComponent } from '@p-parametria/control-usuarios/vendedores/vendedores.component';
import { VendedorFormComponent } from '@p-parametria/control-usuarios/vendedores/vendedor-form.component';
import { CamposCustomizablesComponent } from '@p-parametria/mantenimiento/campos-customizables/campos-customizables.component';
import { CampoCustomizableFormComponent } from '@p-parametria/mantenimiento/campos-customizables/campo-customizable-form/campo-customizable-form.component';
import { AgregarOpcionFormComponent } from '@p-parametria/mantenimiento/campos-customizables/campo-customizable-form/agregar-opcion-form/agregar-opcion-form.component';
import { CamposCustomizablesCatalogosComponent } from '@p-parametria/mantenimiento/campos-customizables-catalogos/campos-customizables-catalogos.component';
import { CampoCustomizableCatalogoFormComponent } from '@p-parametria/mantenimiento/campos-customizables-catalogos/campo-customizable-catalogo-form/campo-customizable-catalogo-form.component';
import { PantallasCustomizablesComponent } from '@p-parametria/mantenimiento/pantallas-customizables/pantallas-customizables.component';
import { PantallaCustomizableFormComponent } from '@p-parametria/mantenimiento/pantallas-customizables/pantalla-customizable-form/pantalla-customizable-form.component';
import { NuevoCampoModalComponent } from '@p-parametria/mantenimiento/pantallas-customizables/pantalla-customizable-form/nuevo-campo-modal/nuevo-campo-modal.component';
import { AbcLineasComponent } from '@p-parametria/mantenimiento/abc-lineas/abc-lineas.component';
import { LineaFormComponent } from '@p-parametria/mantenimiento/abc-lineas/linea-form.component';
import { AbcResultadosComponent } from '@p-parametria/mantenimiento/abc-resultados/abc-resultados.component';
import { ResultadoFormComponent } from '@p-parametria/mantenimiento/abc-resultados/resultado-form.component';
import { AbcAccionesComponent } from '@p-parametria/mantenimiento/abc-acciones/abc-acciones.component';
import { AbcAccionesFormComponent } from '@p-parametria/mantenimiento/abc-acciones/abc-acciones-form/abc-acciones-form.component';
import { ConsultaLogComponent } from '@p-parametria/portafolio/consulta-log/consulta-log.component';
import { TipoCarteraFormComponent } from '@p-parametria/portafolio/tipoCartera/tipoCartera-form.component';
import { ConceptosFormComponent } from '@p-parametria/portafolio/conceptos/conceptos-form.component';
import { FormaPagoFormComponent } from '@p-parametria/portafolio/formaPago/formaPago-form.component';
import { ListaTelefonosComponent } from '@p-parametria/parametros/lista-telefonos/lista-telefonos.component';
import { TelefonoFormComponent } from '@p-parametria/parametros/lista-telefonos/telefono-form.component';
import { ListaEmpresasComponent } from '@p-parametria/parametros/lista-empresas/lista-empresas.component';
import { EmpresaFormComponent } from '@p-parametria/parametros/lista-empresas/empresa-form.component';
import { ParametrosGeneralesComponent } from '@p-parametria/parametros/parametros-generales/parametros-generales.component';
import { SectoresComponent } from '@p-parametria/mantenimiento/sectores/sectores.component';
import { SectorFormComponent } from '@p-parametria/mantenimiento/sectores/sector-form/sector-form.component';
import { ProFormaComponent } from '@p-parametria/mantenimiento/sectores/proforma/proforma.component';
import { ComentariosComponent } from '@p-parametria/mantenimiento/sectores/comentarios/comentarios.component';
import { FinanzasComponent } from '@p-parametria/mantenimiento/sectores/finanzas/finanzas.component';
import { AnalisisComponent } from '@p-parametria/mantenimiento/sectores/analisis/analisis.component';
import { AnalisisFormComponent } from '@p-parametria/mantenimiento/sectores/analisis/analisis-form/analisis-form.component';
import { ComentarioFormComponent } from '@p-parametria/mantenimiento/sectores/comentarios/comentario-form/comentario-form.component';
import { FinanzaFormComponent } from '@p-parametria/mantenimiento/sectores/finanzas/finanza-form/finanza-form.component';
import { AbcBancosComponent } from '@p-parametria/mantenimiento/abc-bancos/abc-bancos.component';
import { AbcBancosFormComponent } from '@p-parametria/mantenimiento/abc-bancos/abc-bancos-form/abc-bancos-form.component';
import { BusquedaRolesComponent } from '@p-parametria/control-usuarios/busqueda-roles/busqueda-roles.component';  

@NgModule({
  declarations: [
    GenericTableComponent,
    PromocionesComponent,
    PromocionesFormComponent,
    GenericFormComponent,
    FormContentComponent,
    ConfirmDeletionComponent,
    TasasComponent,
    TasasFormComponent,
    TasasHistoricoComponent,
    ConceptosComponent,
    CapitalesComponent,
    CapitalesFormComponent,
    FormaPagoComponent,
    PlazosComponent,
    PlazosFormComponent,
    CiclosFormComponent,
    CiclosComponent,
    IndexFuncionesComponent,
    TipoCarteraComponent,
    MovimientoCajaComponent,
    MovimientoCajaFormComponent,
    EstatusComponent,
    EstatusFormComponent,
    SubestatusComponent,
    SubestatusFormComponent,
    ContabilidadPromocionComponent,
    DefinicionesComponent,
    DefinicionesFormComponent,
    EstatusLegalesComponent,
    EstatusLegalesFormComponent,
    RolComponent,
    RolFormComponent,
    SelectEmpresaComponent,
    SelectMonedaComponent,
    SelectTasaComponent,
    SelectConceptoComponent,
    DefAperturaComponent,
    DefGastosComponent,
    DefBonificacionComponent,
    DefLiquidacionComponent,
    DefCargosCierreComponent,
    DefExtraordinariosComponent,
    DefSubsidioComponent,
    RangosComponent,
    RangosFormComponent,
    VariablesComponent,
    VariablesFormComponent,
    PerfilComponent,
    PerfilFormComponent,
    ContabilidadFormComponent,
    ModulesFormComponent,
    ModulesPermissionComponent,
    SimuladorComponent,
    AuditarComponent,
    ControlPermissionComponent,
    ControlFormComponent,
    ControlFormPermissionComponent,
    FormPermissionComponent,
    TiposCreditoComponent,
    CopiarTiposCreditoDialogComponent,
    TiposCreditoFormComponent,
    DuplicarModeloComponent,
    ProductosComponent,
    ProductosFormComponent,
    AbcMotivosComponent,
    AbcMotivoFormComponent,
    AbcEmpresasComponent,
    AbcEmpresasFormComponent,
    ParametrosVariablesComponent,
    ParametrosVariablesFormComponent,
    AbcEmpresasCustomizablesComponent,
    AbcEmpresasCuentasComponent,
    AbcMonedasComponent,
    AbcMonedasFormComponent,
    AbcEmpresasSucursalesComponent,
    AbcEmpresasSucursalesFormComponent,
    AbcEmpresasPromocionesComponent,
    AbcEmpresasPromocionesFormComponent,
    AbcMonedasParidadesComponent,
    AbcArticulosComponent,
    AbcArticuloFormComponent,
    AbcListaPersonasComponent,
    AbcListaPersonasDialogComponent,
    DestinosComponent,
    DestinoFormComponent,
    RutaCriticaComponent,
    RutaCriticaFormComponent,
    RutasDialogComponent,
    RutaFormDialogComponent,
    ActividadesDialogComponent,
    CopiarRutaDialogComponent,
    ActividadFormDialogComponent,
    CuestionariosComponent,
    CuestionarioDialogComponent,
    TiposDialogComponent,
    NuevoTipoDialogComponent,
    CopiarCuestionarioDialogComponent,
    DocumentosComponent,
    GirosComponent,
    TitulosComponent,
    DocumentoFormComponent,
    GiroFormComponent,
    TituloFormComponent,
    PromocionesCopyComponent,
    PaisesComponent,
    PaisFormComponent,
    ChecklistComponent,
    ChecklistFormComponent,
    PreguntasDialogComponent,
    NuevaPreguntaDialogComponent,
    ParidadesComponent,
    ParidadFormComponent,
    VariablesFinancierasComponent,
    VariableFinancieraFormComponent,
    ZonaCiudadesComponent,
    ZonaCiudadFormComponent,
    ZonaCiudadListComponent,
    ZonaCiudadFormCiudadComponent,
    RenumerarPreguntaDialogComponent,
    GuionesDialogComponent,
    NuevoGuionDialogComponent,
    NuevaOpcionDialogComponent,
    OpcionesDialogComponent,
    ScriptDialogComponent,
    NuevoScriptDialogComponent,
    CapturistasComponent,
    CapturistaFormComponent,
    AnalistasComponent,
    AnalistaFormComponent,
    DefCargosPagosComponent,
    DefInteresesComponent,
    TelemarketingComponent,
    TelemarketingFormComponent,
    GestoresComponent,
    GestoresFormComponent,
    AgendaModalComponent,
    VendedoresComponent,
    VendedorFormComponent,
    CamposCustomizablesComponent,
    CampoCustomizableFormComponent,
    AgregarOpcionFormComponent,
    CamposCustomizablesCatalogosComponent,
    CampoCustomizableCatalogoFormComponent,
    PantallasCustomizablesComponent,
    PantallaCustomizableFormComponent,
    NuevoCampoModalComponent,
    AbcLineasComponent,
    LineaFormComponent,
    AbcResultadosComponent,
    ResultadoFormComponent,
    AbcAccionesComponent,
    AbcAccionesFormComponent,
    ConsultaLogComponent,
    TipoCarteraFormComponent,
    ConceptosFormComponent,
    FormaPagoFormComponent,
    ListaTelefonosComponent,
    TelefonoFormComponent,
    ListaEmpresasComponent,
    EmpresaFormComponent,
    ParametrosGeneralesComponent,
    SectoresComponent,
    SectorFormComponent,
    ProFormaComponent,
    ComentariosComponent,
    FinanzasComponent,
    AnalisisComponent,
    AnalisisFormComponent,
    ComentarioFormComponent,
    FinanzaFormComponent,
    AbcBancosComponent,
    AbcBancosFormComponent,
    BusquedaRolesComponent
  ],
  imports: [
    AppSharedModule,
    MatCardModule,
    MaterialModule,
    MatPaginatorModule,
    MatSortModule,
    CommonModule,
    MatIconModule,
    RouterModule.forChild(ParametriaRoutes),
    NgxCaptchaModule,
    // NgxGraphModule
    PrimeNgModule
  ],
  exports: [GenericTableComponent, GenericFormComponent]
})
export class ParametriaLayoutModule {}
